import { TableColumnKey } from '../../ui-components/scope-ui-table/table-column-key.enum'

export const isColumnVisible = (column) =>
  column.selected &&
  column.key !== TableColumnKey.SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS &&
  (column.isVisible ? column.isVisible() : true) &&
  (column.isVisibleInList ? column.isVisibleInList() : true)
